import { NgModule } from '@angular/core';
import { GCCoreModule } from '@core/_core.module';
import { EmailHeaderBlockComponent } from '../email-header-block/email-header-block.component';
import { ViewEmailModalComponent } from '../view-email-modal/view-email-modal.component';
import { SelectEmailTemplateComponent } from './select-email-template/select-email-template.component';

@NgModule({
  imports: [
    GCCoreModule
  ],
  declarations: [
    SelectEmailTemplateComponent,
    EmailHeaderBlockComponent,
    ViewEmailModalComponent
  ],
  exports: [
    SelectEmailTemplateComponent,
    EmailHeaderBlockComponent,
    ViewEmailModalComponent
  ]
})
export class SelectEmailTemplateModule { }
